module.exports = __webpack_public_path__ + "img/20220411_125543.56d1d897.jpg";